/* eslint-disable react/jsx-no-useless-fragment */
import { useMutation } from "@apollo/client";
import PermanentlyDeleteFinancialsTemplateMutation from "components/financials/modern/graphql/PermanentlyDeleteFinancialsTemplateMutation";
import type {
  IPermanentlyDeleteFinancialsTemplateMutation,
  IPermanentlyDeleteFinancialsTemplateMutationVariables,
} from "components/financials/modern/graphql/__generated__/PermanentlyDeleteFinancialsTemplateMutation.generated";
import type { IFinancialsTemplateFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/FinancialsTemplateFieldsFragment.generated";
import { SimpleTextTooltip } from "components/ui/Tooltip";
import classNames from "components/ui/classNames";
import { TrashIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface PermanentlyDeleteTemplateButtonProps {
  template: IFinancialsTemplateFieldsFragment;
  onPermanentlyDelete?: () => void;
}
export default function PermanentlyDeleteTemplateButton({
  template,
  onPermanentlyDelete,
}: PermanentlyDeleteTemplateButtonProps) {
  const intl = useIntl();
  const [permanentlyDeleteFinancialsTemplate, { loading }] = useMutation<
    IPermanentlyDeleteFinancialsTemplateMutation,
    IPermanentlyDeleteFinancialsTemplateMutationVariables
  >(PermanentlyDeleteFinancialsTemplateMutation, {
    onCompleted: onPermanentlyDelete,
  });

  return (
    <SimpleTextTooltip content={intl.formatMessage({ defaultMessage: "Deletar para sempre", id: "MV6/kn" })}>
      <button
        type="button"
        disabled={loading}
        className={classNames(
          "group relative -ml-px h-10 items-center bg-slate-50/60 p-2",
          "rounded-none rounded-r-xl border  border-slate-200 text-slate-600",
          "dark:border-slate-950 dark:bg-slate-700",
          "hover:bg-slate-50/60",
          "focus-visible:outline-none",
          "focus-visible:ring-1 focus-visible:ring-offset-1",
          "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
          "focus-visible:border-transparent focus-visible:bg-gray-50",
          "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
          "disabled:cursor-not-allowed disabled:opacity-50",
          {
            "hover:bg-rose-50 hover:text-rose-600": !loading,
            "hover:bg-violet-50 hover:text-violet-600": loading,
          },
        )}
        onClick={() => {
          permanentlyDeleteFinancialsTemplate({
            variables: {
              objectId: template.objectId,
            },
          });
        }}
      >
        <TrashIcon className="h-4 w-4 text-current" />
      </button>
    </SimpleTextTooltip>
  );
}
